<template>
<div style="margin-top: 100px; background: rgba(238, 238, 238, 0.42); ">
     <v-row>
          <v-col v-if="status[0].status == 0" cols="12" md="3" lg="3" sm="4"></v-col>
          <v-col v-if="status[0].status == 1" class="newContainer mx-auto" cols="12" md="3" lg="3" sm="4">

               <!-- <v-img width="60" :src="require('@/assets/logo.png')"></v-img> -->
               <div class=" mb-5">
                    <h1 v-if="!isLoading" class="textSizeST">{{ $t('envEmail') }}</h1>
                    <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
                    <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D')"></div>
               </div>
               <v-row v-if="!isLoading">
                    <v-col cols="12">
                         <v-text-field hide-details background-color="#fff" v-model="form.nom" :label="$t('vNom')" :color="(settings[0] ? settings[0].color : '#2F839D')" dense append-icon="mdi-account-outline" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="12">
                         <v-text-field hide-details background-color="#fff" v-model="form.email" :label="$t('email')" :color="(settings[0] ? settings[0].color : '#2F839D')" dense append-icon="mdi-email-outline" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="12">
                         <v-text-field type="number" hide-details background-color="#fff" v-model="form.telephone" :label="$t('phone')" :color="(settings[0] ? settings[0].color : '#2F839D')" dense append-icon="mdi-phone" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12">
                         <v-textarea hide-details rows="3" background-color="#fff" v-model="form.message" :label="$t('msg')" :color="(settings[0] ? settings[0].color : '#2F839D')" dense append-icon="mdi-message-outline" outlined></v-textarea>
                    </v-col>
                    <v-col @click="$refs.img.click()" cols="8">
                         <input type="file" ref="img" hidden @change="selectImage">
                         <v-text-field dense hide-details outlined background-color="#fff" :color="(settings[0] ? settings[0].color : '#2F839D') " :label="$t('chargOrd') " clearable append-icon="mdi-file" readonly @change="selectImage" v-model="fileExmpl"> </v-text-field>
                    </v-col>
                    <v-col cols="3">
                         <v-btn v-if="!isLoad" dark :color="(settings[0] ? settings[0].color : '#2F839D')" @click="sendToEmail">{{ $t('send') }}</v-btn>
                         <span :style="'color:'+(settings[0] ? settings[0].color : '#2F839D')" v-else>{{ $t('patienter') }}</span>
                    </v-col>
               </v-row>
               <v-skeleton-loader v-else ref="skeleton" type=" article, actions"></v-skeleton-loader>

          </v-col>
          <v-col class="  hidden-sm-and-down" cols="12" md="3" lg="3" sm="2">
               <div class=" mb-5">
                    <h1 v-if="!isLoading" class="textSizeST">{{ $t('horaire') }}</h1>
                    <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
                    <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D')"></div>
               </div>
               <div>
                    <v-row v-if="!isLoading">
                         <v-col class="py-1 textFooter " style='background: #ddd' cols="5">{{$t('samedi')}}</v-col>
                         <v-col class="py-1 textFooter " style='background: #ddd' cols="7">{{ settings[0] ? JSON.parse(settings[0].datee)["samedi"] : '-------------'  }}</v-col>
                         <v-col class="py-1 textFooter " cols="5">{{$t('dimanche')}}</v-col>
                         <v-col class="py-1 textFooter " cols="7"> {{ settings[0] ? JSON.parse(settings[0].datee)["dimanche"] : '-------------'  }}</v-col>
                         <v-col class="py-1 textFooter " style='background: #ddd' cols="5">{{$t('lundi')}}</v-col>
                         <v-col class="py-1 textFooter " style='background: #ddd' cols="7"> {{ settings[0] ? JSON.parse(settings[0].datee)["lundi"] : '-------------'  }}</v-col>
                         <v-col class="py-1 textFooter " cols="5">{{$t('mardi')}}</v-col>
                         <v-col class="py-1 textFooter " cols="7"> {{ settings[0] ? JSON.parse(settings[0].datee)["mardi"] : '-------------' }}</v-col>
                         <v-col class="py-1 textFooter " style='background: #ddd' cols="5">{{$t('mercredi')}}</v-col>
                         <v-col class="py-1 textFooter " style='background: #ddd' cols="7"> {{ settings[0] ? JSON.parse(settings[0].datee)["mercredi"] : '-------------' }}</v-col>
                         <v-col class="py-1 textFooter " cols="5">{{$t('jeudi')}}</v-col>
                         <v-col class="py-1 textFooter " cols="7"> {{ settings[0] ? JSON.parse(settings[0].datee)["jeudi"] : '-------------' }}</v-col>
                         <v-col class="py-1 textFooter " style='background: #ddd' cols="5">{{$t('vendredi')}}</v-col>
                         <v-col class="py-1 textFooter " style='background: #ddd' cols="7"><span style="color:red">{{ settings[0] ? JSON.parse(settings[0].datee)["vendredi"] : '-------------' }}</span></v-col>
                    </v-row>
                    <v-skeleton-loader v-else ref="skeleton" type=" article, actions"></v-skeleton-loader>
               </div>
          </v-col>

          <v-col class="newContainer" cols="12" md="3" lg="3" sm="4">
               <div class=" mb-5">
                    <h1 v-if="!isLoading" class="textSizeST">{{ $t('contacts') }}</h1>
                    <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
                    <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D')"></div>
               </div>
               <div v-if="!isLoading">
                    <p>
                         <v-icon :color=" (settings[0] ? settings[0].color : '#2F839D')" class="mx-3">mdi-map-marker</v-icon>{{ (settings[0] && settings[0].adresse ) ? settings[0].adresse : '-----------------' }}
                    </p>
                    <v-btn style="border-radius:30px" class="" @click="voirPlane" width="80%" outlined :color=" (settings[0] ? settings[0].color : '#2F839D')">{{ $t('voirPlane') }}
                         <v-icon size="20" :color=" (settings[0] ? settings[0].color : '#2F839D')" class="mx-3">mdi-trending-neutral</v-icon>
                    </v-btn><br><br>
                    <p>
                         <v-icon :color=" (settings[0] ? settings[0].color : '#2F839D')" class="mx-3">mdi-phone</v-icon>{{ settings[0] ? settings[0].telephone.replace(/ /g, "")  : '-- -- -- -- -- --' }}
                    </p>
                    <p>
                         <v-icon :color=" (settings[0] ? settings[0].color : '#2F839D')" class="mx-3">mdi-email</v-icon>{{ settings[0] ? settings[0].email : '-- -- -- -- -- --' }}
                    </p>
                    <div class="">
                         <v-btn class="mx-6" icon>
                              <a :href="settings[0] ? settings[0].facebook : 'https://www.facebook.com/'" style="text-decoration:none" target="blank">
                                   <v-icon size="30" :color="(settings[0] ? settings[0].color : '#2F839D')"> mdi-facebook</v-icon>
                              </a>
                         </v-btn>
                         <v-btn icon>
                              <a :href="settings[0] ? settings[0].twitter : 'https://twitter.com/'" style="text-decoration:none" target="blank">
                                   <v-icon size="30" class="mx-6" :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-twitter</v-icon>
                              </a>
                         </v-btn>
                    </div>
               </div>
               <v-skeleton-loader v-else ref="skeleton" type=" article, actions"></v-skeleton-loader>
          </v-col>
     </v-row>

     <div :style="'margin-bottom: -12px; background: ' + (settings[0] ? settings[0].color : '#2F839D')">

          <v-row>
               <v-col class="mx-12" cols="12" lg="8" md="8" sm="8">
                    <span class="enTet2">© Copyright Voisinage PC. All Rights Reserved</span>
               </v-col>
               <v-col class="hidden-sm-and-down" cols="12" lg="2" md="2" sm="2">
                    <span class="enTet2">Power by : <a href="http://www.voisinagepc.com/" class="enTet2">Voisinage PC</a></span>
               </v-col>
          </v-row>
     </div>

     <v-dialog v-model="dialog" max-width="600">
          <v-card>
               <v-card-title class="headline">{{ $t('') }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="red" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <div style="height:500px">
                         <GmapMap :options="{
                                             zoomControl: true,
                                             mapTypeControl: true,
                                             scaleControl: true,
                                             streetViewControl: true,
                                             rotateControl: true,
                                             fullscreenControl: true,
                                             disableDefaultUi: true
                                        }" ref="mapRef" :center="{lat:settings[0] ? parseFloat(settings[0].lat) : 1.265787878,lng:settings[0] ? parseFloat(settings[0].lang) : 36.232365488}" :zoom="15" map-type-id="terrain" style="width: 100%; height: 100%">
                              <GmapMarker :key="index" v-for="(m, index) in markers" :position="{lat:settings[0] ? parseFloat(settings[0].lat) : 1.265787878,lng:settings[0] ? parseFloat(settings[0].lang) : 36.232365488}" :clickable="false" :draggable="false" />
                         </GmapMap>

                    </div>
               </v-card-text>
          </v-card>
     </v-dialog>

     <v-dialog v-model="dialog22" persistent max-width="400">
          <v-card>
               <v-card-title class="headline">
                    {{ $t('checkEmailHeader') }}
                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="red" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <p>{{ $t('textEmailVirify') }}</p>
                    <v-text-field class="mb-4" hide-details v-model="codeFromFeild" dense :label="$t('code')" outlined></v-text-field>
                    <a @click="sendToEmail">{{ $t('resyee') }}</a>
               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :class="this.localLang == 'fr' ? 'mr-3' : 'ml-3'" v-if="!isLoad" dark :color="(settings[0] ? settings[0].color : '#2F839D')" @click="sendDemande">{{ $t('virify') }}</v-btn>
                    <span :style="'color:'+(settings[0] ? settings[0].color : '#2F839D')" v-else>{{ $t('patienter') }}</span>

               </v-card-actions>
          </v-card>
     </v-dialog>
</div>
</template>

<script>
export default {

     data: () => ({
          compt: 0,
          codeFromEmail: '',
          codeFromFeild: '',
          fileExmpl: '',
          dialog: false,
          dialog22: false,
          isLoad: false,
          form: {},
          center: {
               lat: 36.258265117286996,
               lng: 2.228445082902901
          },
          markers: [{
               position: {
                    lat: 36.258265117286996,
                    lng: 2.2286449074745107
               }
          }, ],
          horaire: {},
     }),

     methods: {
          close() {
               this.dialog = false
               this.dialog22 = false
          },
          voirPlane() {
               this.dialog = true
          },
          init() {
               this.fileExmpl = ''
               this.form = {
                    type: 0,
                    nom: '',
                    email: '',
                    telephone: '',
                    message: '',
                    reponse: '',
                    types: 0,
                    date_rendez_vous: '',
                    domainName: document.location.origin,
                    file: '',
               }
          },
          selectImage(e) {
               const file = e.target.files[0]
               this.form.file = file
               this.fileExmpl = file.name
          },
          sendDemande() {
               if (this.codeFromEmail.success.match(/454E58D460212Y(.*)R44R554/)[1] == this.codeFromFeild+"") {
                    this.isLoad = true
                    var url = "getDemandes/addDemandes"
                    var commit = "getDemandes"
                    this.$Register({
                         data: JSON.stringify(this.form),
                         file: this.form.file
                    }, url, commit).then((res) => {
                         this.init()
                         this.dialog22 = false
                         this.codeFromEmail = ""
                         this.codeFromFeild = ""
                         this.isLoad = false
                    }).catch((err) => {
                         this.isLoad = false
                    })
               } else {
                    localStorage.getItem('lang') == 'fr' ? toastr.error("Ce code est faux!", "Attention") : toastr.error("هذا الرمز خاطئ!", "تحذير")
               }
          },
          sendToEmail() {
               if (this.compt <= 3) {
                    this.compt++
                    this.isLoad = true
                    var url = "getDemandes/virifyEmail"
                    var commit = "getDemandes"

                    this.$Register({
                         data: JSON.stringify(this.form)
                    }, url, commit).then((res) => {
                         this.codeFromEmail = res
                         this.dialog22 = true
                         this.isLoad = false
                    }).catch((err) => {
                         this.isLoad = false
                    })
               } else {
                    this.dialog22 = false
                    this.compt = 0
                    localStorage.getItem('lang') == 'fr' ? toastr.warning("Vérifiez l'e-mail s'il est correct", "Attention") : toastr.warning("تأكد من البريد الإلكتروني إذا كان صحيح", "تحذير")
               }
          }
     },
     created() {
          this.init()
     }
}
</script>

<style scoped>
.textFooter {
     margin-top: 10px !important;
     color: #777 !important;
     font-weight: 900 !important;
}

.enTet2 {
     text-decoration: none;
     color: #fff;
}
</style>
